import React from "react";
import { Col, Row, Carousel } from "react-bootstrap";
import { Loader, LoaderContainer } from "../../Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLink,
  faRocket,
  faToolbox,
  faClipboardList,
  faDrum,
  faLightbulb,
  faLayerGroup,
  faCodeBranch,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import "./Deliverable.css";

const Deliverable = function (props) {
  const renderLoader = () => {
    return (
      <Row className="hidden-xs">
        <Col sm={5}>
          <LoaderContainer>
            <Loader align="left" sizes={[40, 40]} spacer={10} />
            <Loader align="left" sizes={[60, 20]} spacer={20} />
            <Loader align="left" sizes={[70, 16]} spacer={10} />
            <Loader align="left" sizes={[80, 16]} spacer={10} />
            <Loader align="left" sizes={[70, 16]} spacer={10} />
            <Loader align="left" sizes={[80, 16]} spacer={10} />
            <Loader align="left" sizes={[90, 16]} spacer={10} />
            <Loader align="left" sizes={[80, 16]} spacer={10} />
            <Loader align="left" sizes={[70, 16]} spacer={10} />
            <Loader align="left" sizes={[80, 16]} spacer={10} />
            <Loader align="left" sizes={[90, 16]} spacer={10} />
            <Loader align="left" sizes={[80, 16]} spacer={10} />
            <Loader align="left" sizes={[70, 16]} spacer={10} />
          </LoaderContainer>
        </Col>
        <Col sm={7}>
          <LoaderContainer>
            <Loader sizes={[100, 360]} />
          </LoaderContainer>
        </Col>
      </Row>
    );
  };

  const renderComponent = () => {
    let currentDeliverable = props.project.deliverables[props.activeTabIndex];
    return (
      <div className="Deliverable__ctn hidden-xs">
        <Row>
          {/* Info column left */}
          <Col sm={5}>
            <div className="Deliverable__leftItem">
              {currentDeliverable.label ? (
                <h2 className="Deliverable__item__title">
                  {currentDeliverable.label}
                </h2>
              ) : null}
              {currentDeliverable.url ? (
                <div className="Deliverable__item__url">
                  <a href={`${currentDeliverable.url}`} target="_blank">
                    {currentDeliverable.url}
                  </a>
                </div>
              ) : null}
            </div>

            {/* Component synopsis */}
            <Row className="Deliverable__leftItem">
              <Col md={12}>
                <p className="Deliverable__synopsis">
                  {currentDeliverable.synopsis}
                </p>
              </Col>
            </Row>

            {/* Component attributes */}
            {currentDeliverable.attributes.map((attr, index) => {
              return (
                <Row className="Deliverable__leftItem" key={index}>
                  <Col sm={12}>
                    <div className="Deliverable__item__subtitle">
                      <span className="Deliverable__item__iconCtn">
                        <FontAwesomeIcon
                          icon={getAttrHeadingIcon(attr.heading)}
                        />
                      </span>
                      {attr.heading}
                    </div>

                    {attr.contents.constructor.name === "Array" && (
                      <div className="Deliverable__attributeTags">
                        {attr.contents.map((entry, index) => (
                          <div
                            key={index}
                            className="Deliverable__attributeTag"
                          >
                            {entry}
                          </div>
                        ))}
                      </div>
                    )}

                    {attr.contents.constructor.name === "String" && (
                      <p className="Deliverable__synopsis">{attr.contents}</p>
                    )}
                  </Col>
                </Row>
              );
            })}
          </Col>

          {/* Media contents */}
          {currentDeliverable.media && (
            <Col sm={7}>
              <Row>
                <Col sm={12} className="center-block">
                  {currentDeliverable.media.type === "CAROUSEL" && (
                    <div className="img-responsive jp-img-stationery jp-toggle-content">
                      <Carousel interval={null} className="bo-carousel">
                        {currentDeliverable.media.entries.map(
                          (entry, index) => {
                            return (
                              <Carousel.Item key={index}>
                                <img
                                  src={entry.url}
                                  title={entry.title}
                                  alt={entry.title}
                                  onClick={() => {
                                    if (entry.pageUrl)
                                      openNewTab(entry.pageUrl);
                                  }}
                                  className={entry.pageUrl && "pointer"}
                                />
                              </Carousel.Item>
                            );
                          }
                        )}
                      </Carousel>
                    </div>
                  )}

                  {(currentDeliverable.media.type === "TABS" ||
                    currentDeliverable.media.type === "IMG") && (
                    <div className="Deliverable__ImageContainer">
                      {getMediaComponent(
                        currentDeliverable.media.entries[props.activeMediaIndex]
                      )}
                    </div>
                  )}
                </Col>
              </Row>

              {/* Toggle menu  */}
              {currentDeliverable.media.type === "TABS" && (
                <Row>
                  <Col sm={12}>
                    <div className="Deliverable__toggleButtonsCtn">
                      {currentDeliverable.media.entries.map((entry, index) => {
                        let activeMediaClass =
                          props.activeMediaIndex === index
                            ? "Deliverable__toggleButton--active"
                            : "";
                        return (
                          <div
                            className={`Deliverable__toggleButton ${activeMediaClass}`}
                            key={index}
                            onClick={(e) => props.handleMediaToggle(index, e)}
                          >
                            {entry.label}
                          </div>
                        );
                      })}
                    </div>
                  </Col>
                </Row>
              )}
            </Col>
          )}
        </Row>
      </div>
    );
  };

  const getMediaComponent = (entry) => {
    if (isYoutubeVideo(entry.url)) {
      return (
        <div className="jp-video-container-noxs">
          <div className="embed-responsive embed-responsive-16by9">
            <iframe
              className="embed-responsive-item"
              src={entry.url}
              title={entry.title}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      );
    }

    if (isImage(entry.url)) {
      let _className = "Deliverable__stationery img-responsive";
      if (entry.pageUrl) _className += " pointer";

      return (
        <img
          src={entry.url}
          className={_className}
          alt={entry.title}
          title={entry.title}
          onClick={() => {
            if (entry.pageUrl) openNewTab(entry.pageUrl);
          }}
        />
      );
    }
  };

  const getAttrHeadingIcon = (attrHeading) => {
    if (attrHeading === "web technologies") return faRocket;
    if (attrHeading === "attributes") return faClipboardList;
    if (attrHeading === "tools") return faToolbox;
    if (attrHeading === "gamification of music") return faDrum;
    if (attrHeading === "dev stack") return faLayerGroup;
    if (attrHeading === "contribution") return faCodeBranch;
    if (attrHeading === "3rd parties") return faLink;
    if (attrHeading === "publication" || attrHeading === "abstract")
      return faFileAlt;
    return faLightbulb;
  };

  const openNewTab = (pageUrl) => {
    window.open(pageUrl, "_blank");
  };

  return props.loading ? renderLoader() : renderComponent();
};

function isYoutubeVideo(url) {
  return url.indexOf("youtube.com") !== -1;
}

function isImage(url) {
  return url.indexOf(".png") !== -1 || url.indexOf(".jpg") !== -1;
}

export default Deliverable;



// WEBPACK FOOTER //
// ./src/components/Project/Deliverable/Deliverable.js